import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    ModelItems: [],
};

const modelSlice = createSlice({
    name: 'Model',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getModelSuccess(state, action) {
            state.isLoading = false;
            state.ModelItems = action.payload;
        },
    },
});

export default modelSlice.reducer;

export const { startLoading, hasError, getModelSuccess } = modelSlice.actions;

export const getAllModels = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/model/get-all-model');
        dispatch(getModelSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addModel = (Model, Series) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const response = await axios.post('attributes/model/model-add', {
            Model,
            Series,
            AddedBy: `${currentUser?.firstName} ${currentUser?.lastName}`
        })
        dispatch(getAllModels());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteModel = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/model/model-delete/${id}`);
        dispatch(getAllModels());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateModel = (Model, Brand, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/model/model-update/${id}`, {
            Model,
            Brand
        });
        dispatch(getAllModels());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};